import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateNotifications } from "web_myplann/Api/Notifications/notificatioKeys";
import { patchNotificationsReadV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useNotificationsMarkAsReadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			(notificationIds: number[]) =>
				patchNotificationsReadV2({ notificationIds }),
			{ skipToastFor: true },
		),
		onSettled: () => {
			invalidateNotifications(queryClient);
		},
	});
};
